// Shared formatting + status helpers for Working Actor.

export function formatDate(value) {
  if (!value) return "—";
  try {
    const d = new Date(String(value).slice(0, 10) + "T00:00:00");
    return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  } catch {
    return String(value);
  }
}

export function formatDateShort(value) {
  if (!value) return "—";
  try {
    const d = new Date(String(value).slice(0, 10) + "T00:00:00");
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  } catch {
    return String(value);
  }
}

export function formatTime(hhmm) {
  if (!hhmm) return "—";
  const [h, m] = String(hhmm).split(":").map(Number);
  if (isNaN(h)) return hhmm;
  const period = h >= 12 ? "PM" : "AM";
  const hr = h % 12 === 0 ? 12 : h % 12;
  return `${hr}:${String(m || 0).padStart(2, "0")} ${period}`;
}

export function currency(n) {
  const v = Number(n || 0);
  return `$${v.toFixed(2)}`;
}

// Redundant status coding: color + shape + word.
// shapes: circle | triangle | pentagon | square
export function statusMeta(raw) {
  const s = String(raw || "").toLowerCase();
  if (["confirmed", "approved", "paid", "sent", "active"].includes(s))
    return { label: cap(s), shape: "circle", color: "#2E6F40" };
  if (["pending", "due", "draft"].includes(s))
    return { label: cap(s), shape: "triangle", color: "#D98A2C" };
  if (["overdue", "declined", "dropped", "action", "action needed"].includes(s))
    return { label: cap(s), shape: "pentagon", color: "#6E2433" };
  // scheduled / waitlisted / taught / closed / info / inactive
  return { label: cap(s) || "Info", shape: "square", color: "#857E72" };
}

function cap(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// "Date added" with an explicit zone + label — never the unzoned formatter above.
export function formatPT(iso) {
  if (!iso) return "—";
  try {
    return (
      new Date(iso).toLocaleString("en-US", {
        timeZone: "America/Los_Angeles",
        month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
      }) + " PT"
    );
  } catch {
    return String(iso);
  }
}

export function classDayTime(cls) {
  if (!cls) return "";
  let wd = "";
  try {
    wd = new Date(String(cls.date).slice(0, 10) + "T12:00:00").toLocaleDateString("en-US", { weekday: "long" });
  } catch {}
  const sh = (t) => {
    const [h, m] = String(t || "").split(":").map(Number);
    if (isNaN(h)) return t || "";
    const hr = h % 12 || 12;
    return m ? `${hr}:${String(m).padStart(2, "0")}` : `${hr}`;
  };
  return `${wd}s ${sh(cls.start_time)}–${sh(cls.end_time)}`;
}

export function groupLabel(cls) {
  if (!cls) return "No group yet";
  return `${cls.admin_label || cls.title} · ${classDayTime(cls)}`;
}
